// All fetch functions here accept a callback. The callback will more than likely
// end up being a setState call in the component it is called from.

import UpdoxApi from './updoxapi';

const headers = { 'Content-Type': 'application/json' };

const chooseAccount = (accountId, successCallback, errorCallback) => {
  return UpdoxApi.postApiWithNoDataParam(
    `/api/access/choose-account/${accountId}`,
    headers,
    successCallback,
    errorCallback
  );
};

const createUser = (formValues, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/access/grant/createuser',
    headers,
    JSON.stringify(formValues),
    successCallback,
    errorCallback
  );
};

// POR-615 - deletes require an empty body {}, and in the case of IE throws an "unsupported BodyInit type" error, hence the JSON.stringify().
// Yes, we can write up a deleteMessageWithNoParam call, but as it is, this is one liner that we never need to come back and look at.
const deleteUser = (userId, successCallback, errorCallback) => {
  return UpdoxApi.deleteApi(
    `/api/access/delete/${userId}`,
    headers,
    JSON.stringify({}),
    successCallback,
    errorCallback,
  );
};

const disableUser = (userId, successCallback, errorCallback) => {
  return UpdoxApi.postApiWithNoDataParam(
    `/api/access/disable/${userId}`,
    headers,
    successCallback,
    errorCallback,
  );
};

const enableUser = (userId, successCallback, errorCallback) => {
  return UpdoxApi.postApiWithNoDataParam(
    `/api/access/enable/${userId}`,
    headers,
    successCallback,
    errorCallback,
  );
};

const getAccessUsers = (successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    '/api/access/users',
    headers,
    successCallback,
    errorCallback,
  );
};

const getAccounts = (successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    '/api/access/accounts',
    headers,
    successCallback,
    errorCallback,
  );
};

const grantUserAccess = (formValues, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/access/grant',
    headers,
    JSON.stringify(formValues),
    successCallback,
    errorCallback
  );
};

const removeExpiration = (id, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/access/remove-expiration/',
    headers,
    JSON.stringify({ id }),
    successCallback,
    errorCallback,
  );
};

const updateExpiration = (data, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/access/update-expiration',
    headers,
    JSON.stringify(data),
    successCallback,
    errorCallback,
  );
};

const FamilyAccessApi = {
  chooseAccount,
  createUser,
  deleteUser,
  disableUser,
  enableUser,
  getAccessUsers,
  getAccounts,
  grantUserAccess,
  removeExpiration,
  updateExpiration,
};

export default FamilyAccessApi;



// WEBPACK FOOTER //
// ./src/apis/familyAccess.js